import React, { useState } from 'react'
import PropTypes from 'prop-types'

import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import { SketchPicker, TwitterPicker } from 'react-color'

const DEFAULT_CONVERTER = 'rgba_hex'
const converters = {
  rgba: c => `rgba(${c.rgb.r}, ${c.rgb.g}, ${c.rgb.b}, ${c.rgb.a})`,
  rgb: c => `rgb(${c.rgb.r}, ${c.rgb.g}, ${c.rgb.b})`,
  hex: c => c.hex,

  rgba_rgb: c => c.rgb.a === 1 ? converters.rgb(c) : converters.rgba(c),
  rgba_hex: c => c.rgb.a === 1 ? converters.hex(c) : converters.rgba(c)
}

const PickerDialog = ({
  value,
  onClick,
  onChange
}) => (
  <div style={{ position: 'relative' }}>
    <div style={{ position: 'absolute', zIndex: '2' }}>
      <div
        style={{ position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px' }}
        onClick={onClick}
      />
      <SketchPicker
        color={value}
        onChange={onChange}
      />
    </div>
  </div>
)

PickerDialog.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func
}

const MakedColorPicker = ({
  onChange,
  convert = DEFAULT_CONVERTER,
  name,
  id,
  hintText,
  placeholder,
  floatingLabelText,
  label,
  TextFieldProps,
  value,
  defaultValue,
  ...custom
}) => {
  const [showPicker, setShowPicker] = useState(false)
  const [internalValue, setValue] = useState(defaultValue)

  return (
    <>
      <Typography
        onClick={() => setShowPicker(true)}
        style={{cursor: 'pointer'}}
        variant="caption"
      >
        <span style={{backgroundColor: value, width: 38, height: 23, marginRight: 8, borderRadius: 3, boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)', display: 'inline-block', float: 'left' }} />
        {label}
      </Typography>

      {showPicker && (
        <PickerDialog
          value={value === undefined ? internalValue : value}
          onClick={() => {
            setShowPicker(false)
            onChange(value)
          }}
          onChange={c => {
            const newValue = converters[convert](c)
            setValue(newValue)
            onChange(newValue)
          }}
        />
      )}
    </>
  )
}

MakedColorPicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  convert: PropTypes.oneOf(Object.keys(converters)),
  name: PropTypes.string,
  id: PropTypes.string,
  hintText: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  floatingLabelText: PropTypes.string,
  TextFieldProps: PropTypes.shape(TextField.propTypes),
  defaultValue: PropTypes.string
}

const ColorPickerField = ({ input: { value, onChange, ...restInput }, meta: { touched, error }, ...restProps }) => (
  <MakedColorPicker
    value={value}
    onChange={onChange}
    errorText={touched && error}
    {...restInput}
    {...restProps}
  />
)

ColorPickerField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object
}

export default MakedColorPicker

export {
  ColorPickerField
}
